import { mapActions, mapGetters, mapMutations } from 'vuex'
import SmartPointWidget from './Widgets/SmartPointWidget'

export default {
  computed: {
    ...mapGetters([
      'getSelectedTransporterSmartPointEnable',
      'getSelectedTransporterSmartPoints',
      'getSelectedSmartPoint',
      'getSmartPointIsSelected',
      'getSelectedTransporterSmartPointsApiError',
      'getSelectedTransporterSmartPointsApiErrorMessage',
      'getIsSmartPointOnlyTransporter',
      'getSelectedTransporterObject',
      'getSelectedTransporterClassName',
      'getIsSmartPointAllOptionsTransporter',
      'getAllTransporterSmartPoints',
      'getSmartPointsEnableForTransporter',
      'previewOrderData'
    ]),
    shouldDisplaySmartPointSelectionError () {
      if (!this.getSelectedTransporterSmartPointEnable) {
        return false
      }

      return (
        !this.getSelectedSmartPoint &&
        this.getIsSmartPointOnlyTransporter
      ) || (
        !this.getIsSmartPointOnlyTransporter &&
        this.getSmartPointIsSelected
      )
    }
  },
  methods: {
    ...mapActions([
      'smartPointUncheck',
      'setSelectedSmartPoint'
    ]),
    ...mapMutations([
      'setSmartPointIsSelected'
    ]),
    shouldEnableSmartPointSelection (transporterClassName) {
      const selectedTransporter = this.getSelectedTransporterObject
      if (!selectedTransporter) {
        return false
      }
      if (selectedTransporter.useTransporterWidget) {
        return false
      }
      return this.getSelectedTransporterSmartPointEnable &&
        this.getSelectedTransporterSmartPoints.length > 0 &&
        transporterClassName === this.getSelectedTransporterClassName
    },
    shouldEnableSmartPointSelectionWidget (transporterClassName) {
      const selectedTransporter = this.getSelectedTransporterObject
      if (!selectedTransporter) {
        return false
      }
      return this.getSelectedTransporterSmartPointEnable &&
        selectedTransporter.useTransporterWidget &&
        transporterClassName === this.getSelectedTransporterClassName
    },
    async resolveDefaultMapInitialization (fireEmitWidgetOpen = true) {
      const selectedTransporter = this.getSelectedTransporterObject
      if (!selectedTransporter) {
        return
      }
      if (selectedTransporter.useTransporterWidget) {
        await this.initializeWidgetForTransporter(selectedTransporter, fireEmitWidgetOpen)
        return
      }
      this.smartPointClickEvent().then(
        () => {
          this.$root.$emit('smartPointClickEvent')
        }
      )
    },
    async smartPointClickEvent () {
      const selectedTransporter = this.getSelectedTransporterObject
      if (!selectedTransporter) {
        return
      }
      if (selectedTransporter.useTransporterWidget) {
        await this.initializeWidgetForTransporter(selectedTransporter)
        this.setSmartPointIsSelected(true)
        return
      }
      await this.$store.dispatch('smartPointClickEvent')
    },
    async initializeWidgetForTransporter (selectedTransporter, fireEmitWidgetOpen = true) {
      const selectedCountry = this.previewOrderData.customerData.country || 'GR'
      const widget = new SmartPointWidget(selectedTransporter, selectedCountry)
      await widget.initializeWidget()
      if (fireEmitWidgetOpen) {
        this.$root.$emit(`${selectedTransporter.class_name}_WidgetOpen`)
      }
    },
    transporterSmartPointsApiError (transporter) {
      if (transporter.deliveryOptionType !== '2') {
        return false
      }
      const data = this.getAllTransporterSmartPoints[transporter.class_name]
      if (data === undefined) {
        return false
      }
      if (data.responseError) {
        return true
      }
    },
    transporterSmartPointsApiErrorMessage (transporter) {
      if (transporter.deliveryOptionType !== '2') {
        return ''
      }
      const data = this.getAllTransporterSmartPoints[transporter.class_name]
      if (data === undefined) {
        return ''
      }
      return data.responseError
    }
  }
}
